import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-portal-flip-carousel',
  templateUrl: './portal-flip-carousel.component.html',
  styleUrl: './portal-flip-carousel.component.scss'
})
export class PortalFlipCarouselComponent implements OnInit, OnDestroy {
  @Input({required: true}) images: string[];
  currentIndex = 0;
  intervalId: any;
  fileUrl = environment.FILE_SERVER_URL;
  @Input() height: any = 64;
  @Output() activeIndex = new EventEmitter<number>();

  ngOnInit() {
    this.intervalId = setInterval(() => this.nextSlide(), 4000);
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    this.activeIndex.emit(this.currentIndex);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }
}
